/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPipelineV1: {
  name: 'pipeline-v1';
  data: string;
} = {
  name: 'pipeline-v1',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3a1 1 0 0 1 1-1h1c.147 0 .286.032.411.088A2 2 0 0 1 5 2h4a2 2 0 0 1 .589.088A.996.996 0 0 1 10 2h1a1 1 0 1 1 0 2v4h4a6 6 0 0 1 6 6v6a1 1 0 1 1 0 2h-1a.997.997 0 0 1-.411-.088A1.998 1.998 0 0 1 19 22h-4c-.205 0-.403-.03-.589-.088A.997.997 0 0 1 14 22h-1a1 1 0 1 1 0-2v-4H9a6 6 0 0 1-6-6V4a1 1 0 0 1-1-1Zm3 5v2a4 4 0 0 0 4 4h4a2 2 0 0 1 2 2h4v-2a4 4 0 0 0-4-4h-4a2 2 0 0 1-2-2H5Zm4-2H5V4h4v2Zm10 12h-4v2h4v-2Z" fill="currentColor"/></svg>`,
};
